import EFPicture from '@elem/compCommon/EFPicture';
import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EfSpec from '@elem/ui/ef-spec';

export default function WhatInBox() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('theProduct.WhatInBox');

    const { locale } = useRouter();
    const IMGS = [
        'https://websiteoss.ecoflow.com/upload/image/1731921653886/125w_box_1.png',
        'https://websiteoss.ecoflow.com/upload/image/1731921654115/125w_box_2.png',
        'https://websiteoss.ecoflow.com/upload/image/1731921655180/125w_box_3.png',
        'https://websiteoss.ecoflow.com/upload/image/1732091901388/125w_box_4.png',
        'https://websiteoss.ecoflow.com/upload/image/1732091901564/125w_box_5.png',
        'https://websiteoss.ecoflow.com/upload/image/1731921654985/125w_box_6.png',
        'https://websiteoss.ecoflow.com/upload/image/1731921654369/125w_box_7.png',
    ];

    return (
        <div className={`${styles.TheComp} sp-125w-common`}>
            <EfSpec />
            <div className="info center">
                <p className="title">{t('title')}</p>
            </div>
            <ul className="grid">
                {[1, 2, 3, 4, 5, 6, 7]?.map((item: any, k: number) => (
                    <li className={`box box-${item}`} key={k}>
                        <div className="box-img">
                            <EFPicture src={IMGS[k]} alt={t(`what_in_box_title_${k + 1}`)} />
                        </div>
                        <div className="box-content">
                            <p className="text">{t(`what_in_box_title_${k + 1}`)}</p>
                            {item !== 7 && <p className="desc">{t(`what_in_box_desc_${k + 1}`)}</p>}
                        </div>
                    </li>
                ))}
            </ul>
            {/* <p className="tip">{t('what_in_box_tips')}</p> */}
        </div>
    );
}
